<template>
  <div class="input">
    <span
      v-if="label"
      class="input__label">
            {{label}}
    </span>
    <el-input
              class="input__value"
              :placeholder="placeholder"
              v-model="data"/>
  </div>
</template>
<script>
export default {
  name: 'input-with-label',
  props: {
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    value: {
      type: String,
    },
  },
  computed: {
    data: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss">
.input {
  &__label{
    display: block;
    margin-bottom: 2px;
    font-size: $--font-size-small;
  }
}
</style>
